import {compose} from 'redux';
import {CopyInput} from '../../../components/copy-input';
import edap, {TYPES} from '../edap';
import React, {Component} from 'react';
import {SHARE__24} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import {withRouter} from 'react-router-dom';
import {withTranslationsAsProps} from '../../../components/translations';

export class ShareUrl extends Component {
    static defaultProps = {
        boardId: null,
        endDate: null,
        desc: '',
        location: {},
        startDate: null,
        title: ''
    }

    // withRouter causes unnecessary renders
    shouldComponentUpdate() {
        return false;
    }

    onCopyClick = () => {
        const {boardId, endDate, startDate} = this.props;
        edap.copyClick(boardId, endDate, startDate, TYPES.SHARE);
    }

    onCopyUrl = () => {
        const {boardId, endDate, startDate} = this.props;
        edap.copyUrl(boardId, endDate, startDate, TYPES.SHARE);
    }

    onCutUrl = () => {
        const {boardId, endDate, startDate} = this.props;
        edap.cutUrl(boardId, endDate, startDate, TYPES.SHARE);
    }

    render() {
        const {desc, isMobile, location, title} = this.props;
        const url = `${window.location.protocol}//${window.location.host}${location.pathname}`;
        return (
            <React.Fragment>
                <h5 className="flex-row">
                    <SVGIcon className="margin-right-2x" markup={SHARE__24} />
                    {title}
                </h5>
                <CopyInput
                    id="trip-board-share-url"
                    isMobile={isMobile}
                    onCopyClick={this.onCopyClick}
                    onCopyUrl={this.onCopyUrl}
                    onCutUrl={this.onCutUrl}
                    value={url}
                />
                <span className="help-block">{desc}</span>
            </React.Fragment>
        );
    }
}

export default compose(
    withRouter,
    withTranslationsAsProps({
        'tripboards.share.desc': 'desc',
        'tripboards.share.link': 'title'
    })
)(ShareUrl);


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/share-url.js